<script>
    import VCardGeneric from "./vCardGeneric"
    import VCardSolution from "./vCardSolution"
    import vEllipsisLoader from "./vEllipsisLoader";

    export default {
        components: {
    VCardGeneric,
    VCardSolution,
            vEllipsisLoader
        },
        name: "eda-list",
        data() {
            return {
                enteringRoute: true,
                leavingRoute: false
            }
        },
        props: {
            heading: {type: String, default: ""},
            label: {type: String, default: ""},
            itemComponent: {type: String, default: "v-card-generic"},
            items: {
                type: Array, default: function () {
                    return []
                }
            },
        },
        computed: {
            mod6() {
                return this.items.length % 6 === 0;
            }

        },
        mounted: function () {
            this.enteringRoute = false;
        }
    }
</script>


<template>
    <div class="eda-list">
        <h1 class="eda-list__heading"
            :class="{ 'eda-list__heading--leaving': leavingRoute, 'eda-list__heading--entering': enteringRoute }">
            {{ heading }}
        </h1>

        <v-ellipsis-loader v-if="!items.length"></v-ellipsis-loader>
        <div class="eda-list__items">
            <template v-for="item in items">
                <div class="eda-list__item" :class="{'eda-list__item--mod6': mod6}" v-bind:key="item.id">
                    <component :is="itemComponent" v-bind="item">
                    </component>
                </div>
            </template>
        </div>
    </div>

</template>

<style lang="scss">

    .eda-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 90em;
        width: 100%;
        padding: 1em;
        margin: 0 auto;

    }

    .mq-tablet .eda-list,
    .mq-mobile .eda-list {
        padding: 0.2em;
    }

    .eda-list__heading {
        color: white;
        font-weight: 400;
        padding: 1em 1em 2em 1em;
        font-size: 2em;
        position: relative;
        text-align: center;
        transition: 0.2s ease all;
    }

    .mq-mobile .eda-list__heading,
    .mq-tablet .eda-list__heading {
        font-size: 1.5em;

    }

    .eda-list__heading:after {
        content: '';
        position: absolute;
        bottom: 1em;
        background-color: white;
        width: 2em;
        height: 2px;
        left: 50%;
        transform: translateX(-50%)

    }

    .eda-list__items {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
    }

    .eda-list__item {
        box-sizing: border-box;
        display: flex;
        width: 20%;
        padding: 0.5em;
    }

    .eda-list__item--mod6 {
        width: 16.333333%;
    }

    .mq-laptop .eda-list__item {
        padding: 0.1em;
    }

    .mq-tablet .eda-list__item {
        width: 33.333%;
        padding: 0.1em;
    }

    .mq-mobile .eda-list__item {
        width: 50%;
        padding: 0.1em;
    }

</style>
